import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const ProPricing = ({ size = 61, style = {} }: PropsType) => {
  return (
    <svg
      width={size}
      height={(size / 61) * 60}
      style={style}
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="35.5938"
        y="20"
        width="7"
        height="46.8018"
        rx="3.5"
        transform="rotate(45 35.5938 20)"
        stroke="#003125"
        stroke-width="4"
      />
      <rect
        x="35.5938"
        y="20"
        width="7"
        height="9.86998"
        rx="2"
        transform="rotate(45 35.5938 20)"
        fill="url(#paint0_linear_107_42957)"
        stroke="#003125"
        stroke-width="4"
      />
      <path
        d="M45.6877 4.8833C46.4059 3.3444 48.5941 3.3444 49.3123 4.8833L51.0108 8.52265C51.2095 8.94833 51.5517 9.2905 51.9774 9.48917L55.6167 11.1877C57.1556 11.9059 57.1556 14.0941 55.6167 14.8123L51.9774 16.5108C51.5517 16.7095 51.2095 17.0517 51.0108 17.4774L49.3123 21.1167C48.5941 22.6556 46.4059 22.6556 45.6877 21.1167L43.9892 17.4774C43.7905 17.0517 43.4483 16.7095 43.0226 16.5108L39.3833 14.8123C37.8444 14.0941 37.8444 11.9059 39.3833 11.1877L43.0226 9.48917C43.4483 9.2905 43.7905 8.94833 43.9892 8.52265L45.6877 4.8833Z"
        fill="url(#paint1_radial_107_42957)"
        stroke="#003125"
        stroke-width="4"
      />
      <path
        d="M11.5 15H21.5M16.5 10V20"
        stroke="#003125"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M42.5 42H52.5M47.5 37V47"
        stroke="#003125"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_107_42957"
          x1="38.8277"
          y1="27.5923"
          x2="38.8277"
          y2="22.3916"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EF89E4" />
          <stop offset="0.965" stop-color="#BC5BEB" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_107_42957"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56.9067 3.59351) rotate(133.959) scale(23.6069 12.138)"
        >
          <stop stop-color="#EF89E4" />
          <stop offset="0.34862" stop-color="#BC5BEB" />
          <stop offset="0.584507" stop-color="#EF89E4" />
          <stop offset="0.965" stop-color="#BC5BEB" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default ProPricing;
